/**
 * @flow
 * @relayHash 9337f20ff1e92bf7ce76f01d86ed7491
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RequestRecheckInput = {|
  email: string,
  locale?: ?string,
  mediaId: string,
  startnumber: string,
|};
export type RequestRecheckMutationVariables = {|
  input: RequestRecheckInput
|};
export type RequestRecheckMutationResponse = {|
  +requestRecheck: ?{|
    +status: ?string
  |}
|};
export type RequestRecheckMutation = {|
  variables: RequestRecheckMutationVariables,
  response: RequestRecheckMutationResponse,
|};
*/


/*
mutation RequestRecheckMutation(
  $input: RequestRecheckInput!
) {
  requestRecheck(input: $input) {
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RequestRecheckInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "requestRecheck",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestRecheckPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RequestRecheckMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RequestRecheckMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "RequestRecheckMutation",
    "id": null,
    "text": "mutation RequestRecheckMutation(\n  $input: RequestRecheckInput!\n) {\n  requestRecheck(input: $input) {\n    status\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5cb1114a57397908a88971095b8dde9f';

module.exports = node;
